export default __webpack_public_path__ + "static/media/tax.8a0d1359.jpg";